import { render, staticRenderFns } from "./WannasornConfirmMemberModal.vue?vue&type=template&id=25053eee"
import script from "./WannasornConfirmMemberModal.vue?vue&type=script&lang=js"
export * from "./WannasornConfirmMemberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports